import './style.less';
import { groupBy } from 'lodash';

export default function() {
  const vm = this;
  vm.$onChanges = init;

  function init() {
    const licenses = groupBy(vm.ngModel, 'name');
    vm.licenses = licenses;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/report/reportTopNav/controller.js